import {loadStripe} from "../util/load_stripe";

up.compiler('#credit_card_form', function(form) {
  var spinner = form.querySelector('#credit-card-spinner');

  function stripeResponseHandler(status, response) {
    if (response.error) {
      var baseError = findOrCreateBaseError(form);
      baseError.textContent = response.error.message;
      enableSubmitButton();
    } else {
      var token = response.id;

      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'plan_premium[stripe_token]';
      input.value = token;
      form.append(input);

      up.submit(form)
    }
  }

  function findOrCreateBaseError(form){
    var baseError = form.querySelector('.alert.alert-danger');
    if (baseError == null){
      baseError = document.createElement('div');
      baseError.className = 'alert alert-danger';
      baseError.setAttribute('role', 'alert');

      form.prepend(baseError);
    }
    return baseError;
  }

  function enableSubmitButton(){
    form.querySelector('button[type="submit"]').disabled = false;
    up.element.hide(spinner);
  }

  function disableSubmitButton() {
    form.querySelector('button[type="submit"]').disabled = true;
    up.element.show(spinner);
  }

  disableSubmitButton()

  loadStripe().then(function() {
    enableSubmitButton();
    form.addEventListener('submit', (event) => {
      event.preventDefault();

      disableSubmitButton();
      Stripe.card.createToken(form, stripeResponseHandler);
    });

  })
})
